import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiErrorMessage } from './helpers/apiErrorMessage';

function OtherUserLists() {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [lists, setLists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setError(null);
            try {
                const [userRes, listsRes] = await Promise.all([
                    axios.get(`/api/users/${userId}`),
                    axios.get(`/api/users/${userId}/lists`)
                ]);
                setUser(userRes.data);
                setLists(listsRes.data);
            } catch (err) {
                setError(getApiErrorMessage(err, 'load this user lists'));
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [userId]);

    if (loading) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Loading...</div>;
    }

    if (!user) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">User not found</div>;
    }

    return (
        <div className="min-h-screen bg-gray-900 text-white px-6 pb-10">
            {error && (
                <div className="bg-red-900 border-l-4 border-red-600 p-4 m-4 rounded">
                    <div className="flex justify-between items-center">
                        <p className="text-red-200">{error}</p>
                        <button onClick={() => setError(null)} className="text-red-400 hover:text-red-200 text-2xl">×</button>
                    </div>
                </div>
            )}
            <div className="max-w-4xl mx-auto">
                <button onClick={() => navigate(`/profile/${userId}`)} className="text-gray-400 hover:text-white mb-6 flex items-center gap-2 transition">
                    <i className="fas fa-arrow-left"></i> Back to profile
                </button>
                <h1 className="text-3xl font-bold mb-6">{user.username}'s Lists</h1>

                {lists.length === 0 ? (
                    <p className="text-gray-400">No lists yet.</p>
                ) : (
                    <div className="space-y-4">
                        {lists.map((list) => (
                            <button
                                key={list.listId}
                                onClick={() => navigate(`/profile/${userId}/lists/${list.listId}`)}
                                className="w-full bg-gray-800 hover:bg-gray-700 p-4 rounded-lg transition flex items-center justify-between"
                            >
                                <div className="flex items-center gap-4">
                                    <div className="relative w-[100px] h-[48px] flex-shrink-0">
                                        <img
                                            className="absolute left-0 top-0 w-12 h-12 rounded-lg border border-gray-800 z-30"
                                            src={list.covers?.c1 || 'https://placehold.co/75x75'}
                                            alt="Top cover"
                                        />
                                        <img
                                            className="absolute left-4 top-0 w-12 h-12 rounded-lg border border-gray-800 z-20"
                                            src={list.covers?.c2 || 'https://placehold.co/75x75'}
                                            alt="Middle cover"
                                        />
                                        <img
                                            className="absolute left-8 top-0 w-12 h-12 rounded-lg border border-gray-800 z-10"
                                            src={list.covers?.c3 || 'https://placehold.co/75x75'}
                                            alt="Bottom cover"
                                        />
                                    </div>
                                    <div className="text-left">
                                        <p className="text-white font-semibold">{list.title}</p>
                                        <p className="text-gray-400 text-sm">{list.entriesCount} entries • {list.createdAt}</p>
                                    </div>
                                </div>
                                <span className="text-gray-300">Open</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default OtherUserLists;
